'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isValid = require('./isValid');

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (time) {
  var d = new Date(time);
  return (0, _isValid2.default)(d) ? d : new Date('Invalid');
}; // @flow weak


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/fromTime.js
// module id = 1370
// module chunks = 0 1 2 3 4 5 7 8 9